import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.api.DealerPageloadVerifications.';
  public static readonly supportAccessGranted = `${Id.prefix}supportAccessGranted`;
  public static readonly temporaryAccessLogin = `${Id.prefix}temporaryAccessLogin`;
}

export class LangDealerPageloadVerifications {
  private constructor() {}
  public static supportAccessGranted(): string {
    return interpolate(Id.supportAccessGranted);
  }
  public static temporaryAccessLogin(): string {
    return interpolate(Id.temporaryAccessLogin);
  }
}

export class DealerPageloadVerificationsModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.supportAccessGranted, 'Support Access Granted', 'Title shown when support access is granted');
    register.add(
      Id.temporaryAccessLogin,
      'You are accessing this system using a temporary access login. please logoff when complete',
      'Message shown when user is using a temporary access login'
    );
  }
}
